import config from "../../config";

const api = {
  uri: {
    cursos: 'secure/becas/cursos',
    aspirantes: 'secure/becas/aspirantes'
  }
};

api.postApplicant = async function(applicant, courses) {
  const data = {
    nombre: applicant.name,
    apellido: applicant.lastname,
    edad: applicant.age,
    tipoDocumento: applicant._docType,
    numeroDocumento: applicant._doc,
    telefono: applicant.telephone,
    email: applicant.email,
    domicilioLocalidad: applicant._city,
    domicilioBarrio: applicant._neighbourhood,
    domicilioCalle: applicant._address,
    domicilioNumero: applicant._address_number,
    domicilioPisoDepto: applicant._address_dpto,
    cursosElegidos: courses.map(c => ({curso: c.id, tipoDeBeca: c.scolarship}))
  };

  if (applicant.age < 18) {
    data.encargado = {
      nombre: applicant.mandated_name,
      apellido: applicant.mandated_lastname,
      tipoDocumento: applicant.mandated_docType,
      numeroDocumento: applicant.mandated_doc,
      telefono: applicant.mandated_telephone,
      email: applicant.mandated_email,
      domicilioLocalidad: applicant.mandated_city,
      domicilioBarrio: applicant.mandated_neighbourhood,
      domicilioCalle: applicant.mandated_address,
      domicilioNumero: applicant.mandated_address_number,
      domicilioPisoDepto: applicant.mandated_address_dpto
    };
  }

  return await fetch(`${config.api_url}/${this.uri.aspirantes}`,
  {
    method: 'POST',
    body: JSON.stringify(data),
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  });
}

api.getCourses = async function () {
  const res = await fetch(`${config.api_url}/${this.uri.cursos}`);
  if (res.status !== 200) return [];
  const courses = await res.json();
  if (courses && courses.length > 0) {
    return courses.map((course) => {
      const minAge = parseInt(course.edadMinima, 10);
      const maxAge = parseInt(course.edadMaxima, 10);
      return {
        id: course.id || '',
        name: course.nombre || '',
        description: course["descripción"] || '',
        schedule: Array.isArray(course.horarios) ? course.horarios[0] : course.horarios || '',
        minAge: isNaN(minAge) ? 0 : minAge,
        maxAge: isNaN(maxAge) ? 100 : maxAge,
        school: course.lugar || '',
        availability: course.becasDisponibles || [],
        contact: course.contacto,
        price: course.precio,
        level: course.nivel || '',
        imageUrl: course.imagen || ''
      }
    });
  }
  return [];
}

export default api;



// WEBPACK FOOTER //
// ./src/utils/api/api.js